<template>
  <div class="under-header padding-bottom">
    <div class="container">

      <div class="panel">
        <h1>Información importante</h1>
        <div>
          <p style="text-align: center; margin-bottom: 15px;">Recuerda que todas las horas están en el horario de Barcelona (GMT +2)</p>
          <h3 class="text-centered margin-bottom">Links</h3>
          <div class="buttons margin-bottom">
            <a target="_blank" href="https://www.twitch.tv/hackersupc">Talks en twitch</a>
          </div>
          <div class="buttons margin-bottom" >
            <a target="_blank" href="https://hackfromhome.hackersatupc.org/">Página web</a>
          </div>
          <!-- <div class="buttons margin-bottom">
            <a target="_blank" href="https://hackfromhome.devpost.com/">Devpost</a>
          </div> -->
        </div>
      </div>

      <div class="panel" style="align-self: flex-start;">
          <h1>Contacto</h1>
          <div class="text-centered">
            <span><a  target="_blank" href="https://discord.gg/kkMZfmt">Servidor de discord</a></span>
          </div>
          <div class="text-centered">
            <p class="icon"><i class="fa fa-envelope" aria-hidden="true"></i></p>
            <span><a href="mailto:support@hackersatupc.org" target="_blank">support@hackersatupc.org</a></span>
          </div>
          <div>
            <h3 class="text-centered margin-bottom">Redes sociales</h3>
            <div class="buttons">
              <a class="fb" target="_blank" href="https://www.facebook.com/hackersupc"><i class="fa fa-facebook-official" aria-hidden="true"></i></a>
              <a class="tw" target="_blank" href="https://twitter.com/hackersupc"><i class="fa fa-twitter" aria-hidden="true"></i></a>
              <a class="ig" target="_blank" href="https://instagram.com/hackersupc"><i class="fa fa-instagram" aria-hidden="true"></i></a>
              <a class="yt" target="_blank" href="https://www.youtube.com/channel/UCiiRorGg59Xd5Sjj9bjIt-g"><i class="fa fa-youtube" aria-hidden="true"></i></a>
              <a class="gt" target="_blank" href="https://github.com/hackupc"><i class="fa fa-github" aria-hidden="true"></i></a>
              <a class="me" target="_blank" href="https://medium.com/@hackupc"><i class="fa fa-medium" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>

      <!-- <div class="panel large">
        <div style="text-align: center;">
          <p style="text-align: center; margin-bottom: 15px;">The great minds that create TheGame of HackUPC 2019 had created a daily hacking challenge to everyone who wants to try something different and fresh. <br/> Will you be able to solve everything? <br /> Welcome to... </p>
          <img src="/assets/img/live/advent-logotype.svg" class="image" style="width: 50%; margin-bottom: 15px;"/>
          <div class="buttons margin-bottom">
            <a target="_blank" href="http://adventofcorona.hackersatupc.org/">Start Hacking</a>
          </div>
        </div>
      </div> -->

      <div class="panel large no-margin">
        <h1>Tráiler Hackers@UPC</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/m2NDc1ofYXY" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style scoped>
</style>
